export function publishLevelHeight(node: HTMLElement, propertyName: string = '--level-height') {
  const observer = new ResizeObserver(() => {
    node.style.setProperty(propertyName, `${node.offsetHeight}px`)
  })
  observer.observe(node)

  return {
    destroy() {
      observer.disconnect()
    },
  }
}
